
import axios from '../config/axios';

export const url = '/api/ordenesdecomprabokst'


export const createordenesdecomprabokst = ({
  token,
	nombredelapersonai1agl,
	correov25ao,
	direccindelapersonahbgqc,
	carrito83nbj,
	totalcbxkm,
	telefonol60a6i,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombredelapersonai1agl && correov25ao && direccindelapersonahbgqc && telefonol60a6i ) {

    axios.post(`${url}//create/basic/69e147dbb08e22defc4dddb5`, {
		nombredelapersonai1agl,
		correov25ao,
		direccindelapersonahbgqc,
		carrito83nbj,
		totalcbxkm,
		telefonol60a6i,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombredelapersonai1agl) {
		reject({
			status: 'error',
			info: 'Nombre de la persona no esta definido',
		});
	}  else if (!correov25ao) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!direccindelapersonahbgqc) {
		reject({
			status: 'error',
			info: 'Dirección de la persona no esta definido',
		});
	}  else if (!telefonol60a6i) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

